import { Box, Button, Menu, MenuButton, Spacer, Text } from '@chakra-ui/react';
import ArtistTextSelector from '../../../components/selectors/ArtistTextSelector';
import { t } from 'i18next';
import PhotoSearchLinkButton from './PhotoSearchLinkButton';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ChevronDownIcon } from '../../../icons/chevron.down.svg';
import type { ArtistType } from '../../types/ArtistType';
import NotificationBadge from '../../my-page/components/NotificationBadge';

export default function HomeHeader({
  artists,
  onChangeArtist
}: {
  artists: ArtistType[];
  onChangeArtist: (artist: ArtistType) => void;
}) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-row w-full h-[61px] px-[24px] py-[11px]">
      {artists ? (
        <ArtistTextSelector
          artists={artists}
          onSelected={onChangeArtist}
          alignDropdown="left"
          // @ts-expect-error
          customTextAreaElementMultiple={(artist: ArtistType) => (
            <MenuButton
              height={'40px'}
              as={Button}
              colorScheme=""
              width={'fit-content'}
              padding={0}
              rightIcon={
                <Box
                  height="40px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  marginInlineStart={'-8px'}
                  paddingLeft={'6px'}
                >
                  <ChevronDownIcon
                    width={'22px'}
                    height={'22px'}
                    className="fill-main-light-3 dark:fill-main-dark-3"
                  />
                </Box>
              }
            >
              <Box height="40px" display="flex" alignItems="center" justifyContent="center">
                <Text
                  fontSize={'26px'}
                  fontWeight={700}
                  className="text-main-light-1 dark:text-main-dark-1"
                >
                  {artist?.shortName === 'TXT' ? artist?.shortName : artist?.name}
                </Text>
              </Box>
            </MenuButton>
          )}
          // @ts-expect-error
          customTextAreaElementSingle={(artist) => <DropdownTextOnly artist={artist} />}
          // @ts-expect-error
          customExtraDropdownMenus={[
            {
              name: t('photoCardPage.manageArtist'),
              onClick: () => {
                navigate('/artists/manage');
              }
            }
          ]}
        />
      ) : (
        <Text
          fontSize={'26px'}
          fontWeight={700}
          className="text-main-light-1 dark:text-main-dark-1"
        >
          {'-'}
        </Text>
      )}

      <Spacer />
      <div className="flex flex-row items-center gap-[8px]">
        <PhotoSearchLinkButton />
        <NotificationBadge />
      </div>
    </div>
  );
}

const DropdownTextOnly = ({ artist }: { artist: ArtistType | null }) => {
  return (
    <Menu>
      <MenuButton
        height={'40px'}
        as={Button}
        colorScheme=""
        // @ts-expect-error
        DropdownTextOnly
        className="text-main-light-1 dark:text-main-dark-1"
        width={'fit-content'}
        padding={0}
        rightIcon={
          <Box height="40px" display="flex" alignItems="center" justifyContent="center">
            <ChevronDownIcon
              width={'22px'}
              height={'22px'}
              className="fill-main-light-3 dark:fill-main-dark-3"
              opacity={0}
            />
          </Box>
        }
      >
        <Box height="40px" display="flex" alignItems="center" justifyContent="center">
          <Text
            fontSize={'26px'}
            fontWeight={700}
            className="text-main-light-1 dark:text-main-dark-1"
          >
            {artist?.name}
          </Text>
        </Box>
      </MenuButton>
    </Menu>
  );
};